import { useContext } from 'react';

import useFetchPropertyIntegrationSettings from 'components/domain/integrationSettings/useFetchPropertyIntegrationSettings';
import useFetchPropertyMetadata from 'components/domain/property/useFetchPropertyMetadata';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import CalendarContext from 'pages/stackedCalendar/CalendarContext';
import useAppUser from 'hooks/useAppUser';
import { PricingUpdateStyled } from './PricingUpdates.styles';
import PricingUpdatesChannels from './PricingUpdatesChannels';
import PricingUpdatesDynamicTool from './PricingUpdatesDynamicTool';

const PricingUpdates = () => {
  const { isOwner } = useAppUser();
  const { selectedProperty: propertyUid } = useContext(CalendarContext);
  const { data: integrationSettings, isLoading: isLoadingIntegrationSettings } =
    useFetchPropertyIntegrationSettings({ propertyUid: propertyUid! });
  const { data: propertyMetadata, isLoading: isLoadingPropertyMetadata } =
    useFetchPropertyMetadata({ propertyUid: propertyUid! });

  if (isOwner) {
    return null;
  }

  const isLoading = isLoadingIntegrationSettings || isLoadingPropertyMetadata;

  if (isLoading) {
    return (
      <PricingUpdateStyled>
        <LoadingPlaceholder linesCount={2.28} width="60%" />
      </PricingUpdateStyled>
    );
  }

  return (
    <PricingUpdateStyled data-testid="pricing-updates">
      <PricingUpdatesDynamicTool
        integrationSettings={integrationSettings}
        pricingMetadata={propertyMetadata?.pricingMetadata}
      />
      <PricingUpdatesChannels
        pricingMetadata={propertyMetadata?.pricingMetadata}
      />
    </PricingUpdateStyled>
  );
};

export default PricingUpdates;
